<template>
  <div class="verification flex justify-center">
    <section class="bg-white shadow-xl mt-10 mx-10 rounded-lg px-4 py-8 text-center">
      <h3 class="text-4xl">{{ $t('Please verify your email') }}</h3>
      <p class="text-lg mt-4">
        {{
          $t(
            'We have sent you a verification email. Please check your email inbox and verify your email before you can login.',
          )
        }}
      </p>
      <button
        class="mt-8 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        type="button"
        @click="handleGoToLogin"
      >
        {{ $t('Go to login') }}
      </button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Verification',
  methods: {
    handleGoToLogin() {
      this.$router.push('login');
    },
  },
};
</script>
